import React, { Component } from 'react';
import DateInput from '@material-ui/core/TextField';
import vocabulary from 'constants/vocabulary';
import DateTimeStyles from './DateTime.scss';

const pad = number => String(number).padStart(2, '0');

const toLocalTimestamp = (date, time) => {
  const [year, month, day] = date.split('-').map(Number);
  const [hours, minutes] = time.split(':').map(Number);
  const local = new Date(year, month - 1, day, hours, minutes);
  // The Date constructor treats years 0-99 as 1900-1999, which breaks typing a year digit by digit.
  local.setFullYear(year);
  return local.getTime();
};

export default class DateTime extends Component {
  static defaultProps = {
    value: '',
  };

  extractDateAndTime = (dateObject) => {
    let date = '';
    let time = '';
    if (dateObject && !vocabulary[dateObject]) {
      const local = new Date(dateObject);
      date = `${String(local.getFullYear()).padStart(4, '0')}-${pad(local.getMonth() + 1)}-${pad(local.getDate())}`;
      time = `${pad(local.getHours())}:${pad(local.getMinutes())}`;
    }
    return [date, time];
  };

  handleChange = (e) => {
    const { type, value } = e.target;

    if (value) {
      const [previousDate, previousTime] = this.extractDateAndTime(this.props.value);

      const newValue = type === 'date'
        ? toLocalTimestamp(value, previousTime || '00:00')
        : toLocalTimestamp(previousDate, value);

      this.props.onChange({
        target: {
          name: this.props.name,
          value: newValue,
        },
      });
    } else {
      this.props.onChange({
        target: { value, name: this.props.name },
      });
    }
  };

  handleTimePick = (e) => {
    // We can't pick a time until we pick a date
    if (!this.props.value) return;

    const { value } = e.target;
    if (!value) return;

    this.handleChange({ target: { value, type: 'time' } });
  };

  render() {
    const {
      label,
      value,
      pickerName,
      ...props
    } = this.props;
    const [dateValue, timeValue] = this.extractDateAndTime(value);
    return (
      <div className={DateTimeStyles.rangeDateTimeRow}>
        <DateInput
          {...props}
          className={DateTimeStyles.rangeDateInput}
          label={label}
          InputLabelProps={{ shrink: true }}
          value={dateValue}
          type="date"
          onChange={this.handleChange}
          id={`${pickerName}${props.name}`}
        />
        <DateInput
          className={DateTimeStyles.rangeTimeField}
          label="Time"
          InputLabelProps={{ shrink: true }}
          inputProps={{ step: 60 }}
          disabled={!value}
          value={timeValue}
          type="time"
          onChange={this.handleTimePick}
          id={`${pickerName}${props.name}Time`}
        />
      </div>
    );
  }
}
